export default __webpack_public_path__ + "static/media/combo@3x.ee020d4b.png";